import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { IParamsFileToWriteObject } from '@/courses/interfaces/params-file-to-write-object.interface';
import { IResultFileToWriteObject } from '@/courses/interfaces/result-file-to-write-objecct.interface';
import EdFileToSplitObject from '@/courses/components/ed-file-to-split-object/ed-file-to-split-object.vue';
import { COURSE_MATERIAL_KEYS, FILE_TO_WRITE_OBJECT } from '@/courses/values/courses.values';
import { IParamsDocumentSplitObject } from '@/courses/interfaces/params-document-split-object.interface';
import { emit } from 'process';

@Component({
  components: {
    EdFileToSplitObject
  }
})
export default class EdDocumentToSplitObject extends Vue {

  @Prop() readonly params: IParamsDocumentSplitObject;
  @Prop() readonly product: any; 
  @Prop() readonly onChange: Function;
  @Prop() readonly goToPreviewPages: Function;

  public documentParams: IParamsFileToWriteObject  = { edition: false };
  public documentFile: any  = { type: FILE_TO_WRITE_OBJECT.FILE, data: null };
  public canShowRotation: boolean = false;
  private lastUrl : string = '';
  
  @Emit('onRotateModal')
  onRotateModal(value) {
    return value;
  }

  @Emit('onRotateFileModal')
  onRotateFileModal(value) {
    return value;
  }

  get hasDocument() {
    return this.documentFile.data ? true : false;
  }

  get isDocumentValid() {
    if(this.hasDocument) {
      if(this.documentFile.type == FILE_TO_WRITE_OBJECT.COURSE_MATERIAL) {
        if( this.documentFile.data.isMultimediaFile ) {
          return true;
        } else {
          return this.documentFile.data.start && this.documentFile.data.end;
        }
      }
      return true; 
    }
    return false;
  }

  get enableMaterialPageSelection() {
    return this.documentFile.data && !this.documentFile.data.isMultimediaFile;
  }

  onDocumentChanged(result: IResultFileToWriteObject) {
    this.documentFile.type = result.type;
    this.documentFile.data = result.type == FILE_TO_WRITE_OBJECT.FILE ? result.file : result.cmo;
    this.setOnChange();
  }

  setOnChange() {
    this.$emit('onChange', {
      type: this.documentFile.type,
      data: this.documentFile.data,
      valid: this.isDocumentValid
    });
  }

  setDocumentForEdition() {
    Object.assign(this.documentFile, this.params);
    let file = this.params.type == FILE_TO_WRITE_OBJECT.FILE ? this.params.data : null;
    let cmo = this.params.type == FILE_TO_WRITE_OBJECT.COURSE_MATERIAL ? this.params.data : null;
    this.documentParams.edition = this.params.edition;
    this.documentParams.selected = this.params.type;
    this.documentParams.file = file;
    this.documentParams.cmo = cmo;
  }

  setPagesSelected(data: { end: number, start: number}) {
    this.documentFile.data.end = data.end;
    this.documentFile.data.start = data.start;
    this.setOnChange();
  }    

  goToSelectPages() {
    let edition: boolean = this.documentFile.data.start ? true : false;
    this.$emit('goToPreviewPages', { name: this.params.name , 
    start: this.documentFile.data.start , end: this.documentFile.data.end ,
   edition: edition });
  }

  rotateModal() : void {
    this.onRotateModal(true);
  }

  rotateFileModal() {
    this.onRotateFileModal(true);
  }

  /* Hooks */
  created() {
    if(this.params.edition) {
      if(this.params?.data) {
        this.canShowRotation = true;
      }
      this.setDocumentForEdition();
    } else {
      this.canShowRotation = false;
    }
    this.documentParams.disclamer = this.params.disclamer;
  }
  
}